import { render, staticRenderFns } from "./TheCompanyIllus.vue?vue&type=template&id=baa013b6"
import script from "./TheCompanyIllus.vue?vue&type=script&lang=js"
export * from "./TheCompanyIllus.vue?vue&type=script&lang=js"
import style0 from "./TheCompanyIllus.vue?vue&type=style&index=0&id=baa013b6&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports